const positionOption: PositionOptions = {
    //maximum age in milliseconds of a possible cached position
    maximumAge: 6 * 60 * 1000, //--> 1 hour
    //maximum length of time (in milliseconds) the device is allowed to take in order to return a position
    timeout: 10 * 1000,//--> 10 sec
}

//Check if the browser supports the geolocation
export const browserSupportGeolocation = (): boolean => {
    return !!window.navigator.geolocation;
}
//options if not provided has the cached position age set to 1 hour and the timeout of the response set to 10 seconds
export const getUserPosition = (options: PositionOptions = positionOption): Promise<GeolocationPosition> | undefined => {
    // if browser doesn't support geolocation return
    if (!browserSupportGeolocation())
        return;

    return new Promise((resolve: PositionCallback, reject: PositionErrorCallback | undefined) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, options);
    });
}
